import { Alert, Form } from 'react-bootstrap'
import PropTypes, { string } from 'prop-types'
import LimitDisplay from '../LimitDisplay.jsx'
import { LabelFor } from './LabelFor.jsx'
import { useEffect, useState } from 'react'

export const Input = (props) => {
    const [errorText, setErrorText] = useState(null)
    const [isDirty, setIsDirty] = useState(false)
    const [value, setValue] = useState(props.value || '')

    useEffect(() => {
        setValue(props.value || '')
    }, [props.value])

    const handleInputChange = (e, input = false, dirty) => {
        if (input) return
        const reg = props.onlyNumbers && /^[0-9]+$|^$/
        if (props.onlyNumbers && !e.target.value.match(reg)) return
        if (props.limit) {
            e.target.value = e.target.value.slice(0, props.limit)
        } else {
            e.target.value = e.target.value.slice(0, 255)
        }
        const newValue = input ? e.target.value : e

        if (!input) {
            props.onChange(newValue)
        }

        setValue(newValue)
    }

    return (
        <Form.Group className={`w-100 ${props.labelClassName}`}>
            {!props.hideLabel && (
                <LabelFor
                    label={props.label}
                    id={props.id}
                    tooltipText={props.tooltipText}
                />
            )}
            <Form.Control
                type={props.type}
                id={props.id}
                aria-label={props.ariaLabel ? props.ariaLabel : undefined}
                title={props.title}
                className={props.className}
                readOnly={props.readOnly}
                size={props.size}
                placeholder={props.placeholder}
                disabled={props.disabled}
                value={props.value || ''}
                onChange={(e) => {
                    setErrorText(null)
                    setIsDirty(false)
                    handleInputChange(e, false, false)
                }}
                onBlur={props.onBlur}
            />

            {props.limit && (
                <LimitDisplay
                    limit={props.limit}
                    value={props.value}
                    float={props.limitterFloat || 'end'}
                />
            )}

            {props.errorText && (
                <Alert className='p-1 w-100' variant='danger'>
                    <div className='ms-1'>{props.errorText}</div>
                </Alert>
            )}
        </Form.Group>
    )
}

Input.propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.string,
    placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    disabled: PropTypes.bool,
    errorText: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    size: PropTypes.string,
    limit: PropTypes.number,
    showLimitter: PropTypes.bool,
    onlyNumbers: PropTypes.bool,
    limitterFloat: PropTypes.oneOf(['end', 'start']),
    className: PropTypes.string,
    readOnly: PropTypes.bool,
    title: PropTypes.string,
    type: PropTypes.string,
    id: PropTypes.string,
    ariaLabel: PropTypes.string,
    name: PropTypes.string,
    labelClassName: PropTypes.string,
    statusResponse: PropTypes.string,
    hideLabel: PropTypes.bool,
    tooltipText: PropTypes.string,
}
